import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    // TODO: Sentry entegrasyonu eklenecek
    console.error('[ErrorBoundary] Yakalanan hata:', error);
    console.error('[ErrorBoundary] Hata detayları:', errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-dark-bg px-4">
          <div className="bg-white dark:bg-dark-card rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
            <div className="text-red-500 text-5xl mb-4">⚠</div>
            <h1 className="text-xl font-semibold text-gray-800 dark:text-dark-text mb-2">
              Bir hata oluştu
            </h1>
            <p className="text-gray-600 dark:text-gray-400 mb-6">
              Bir hata oluştu. Sayfayı yenilemeyi deneyin.
            </p>
            <button
              onClick={this.handleReload}
              className="inline-flex items-center justify-center px-6 py-2.5 bg-primary-600 hover:bg-primary-700 text-white font-medium rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 dark:focus:ring-offset-dark-card"
            >
              Sayfayı Yenile
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
